enum CornerType {
    "nw",
    "ne",
    "se",
    "sw",
};

export default CornerType;